import { useEffect } from "react";

export default function useClickOutside(ref, handler) {
    useEffect(() => {
        function listener(event) {
            // If clicking inside the element, ignore
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event); // click was outside
        }

        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);

        return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [ref, handler]);
}
